import { MetaTag } from '../services/meta/meta.service.js';

function getMetaTags(page) {
    if (page === void 0) { page = 'default'; }
    return [
        { name: MetaTag.DESCRIPTION, content: "meta." + page + ".description" },
        { name: MetaTag.KEYWORDS, content: "meta." + page + ".keywords" },
        { name: MetaTag.ROBOTS, content: "meta." + page + ".robots" },
        { name: MetaTag.FB_APP_ID, content: "meta." + page + ".fb-app-id" },
        { name: MetaTag.FB_PAGE_ID, content: "meta." + page + ".fb-page-id" },
        {
            name: MetaTag.OG_DESCRIPTION,
            content: "meta." + page + ".og-description",
        },
        { name: MetaTag.OG_IMAGE, content: "meta." + page + ".og-image" },
        { name: MetaTag.OG_IMAGE_ALT, content: "meta." + page + ".og-image-alt" },
        { name: MetaTag.OG_SITE_NAME, content: "meta." + page + ".og-site-name" },
        { name: MetaTag.OG_TITLE, content: "meta." + page + ".og-title" },
        { name: MetaTag.OG_TYPE, content: "meta." + page + ".og-type" },
        { name: MetaTag.OG_URL, content: "meta." + page + ".og-url" },
        { name: MetaTag.PRERENDER_STATUS_CODE, content: "meta." + page + ".404" },
    ];
}

export { getMetaTags };
